// extracted by mini-css-extract-plugin
export default {"item":"KeywordsMenu_item__xFR8k"};